jQuery(function ($){
   
  $(document).ready(function(){
    $('.yotpo-header-container').appendTo('.yotpo-head');
    $('.best-value').insertBefore('.product-form__buttons .product-form__buttons-row');
   // $('.yotpo-head + div > div:not(.yotpo-header-container)').wrapAll('<div class="reviews_left-col"></div>');


  /*  var element1 =  $('.yotpo-head + div div:nth-child(3)');
    var element2 =  $('.yotpo-reviews-container');

    var wrapper = $('<div class="reviews_left-col"></div>');
    
    element1.add(element2).wrapAll(wrapper);*/
  });
});